import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const updateOrderInformation = (orderDetail) => {
  return api.post(`${ApiEndpointConstants.UPDATE}`, {
    data: JSON.stringify(orderDetail),
    saveToFile: true,
  });
};
